import HeaderAccessibility from './HeaderAccessibility';

export default function HeaderActions() {
	return (
		<div className="header-actions">
			<HeaderAccessibility/>
		</div>
	)
}
